import { Controller } from 'react-hook-form'

import ReactQuill from 'react-quill-new'
import { reactQuillFormats, reactQuillModules } from '../../../../utils/editor/reactQuill'
import SchoolRecordInput from './SchoolRecordInput'
import HtmlPrintBox from '../../../admin/common/HtmlPrintBox'

const BehavioralRemarkTable = ({ register, control, isRead = false }) => {

    const grade = ['g10', 'g11', 'g12']

    return (
        <div>
            <table className='table table-sm table-bordered text-center align-middle'>
                <thead>
                    <tr>
                        <th style={{ width: "80px" }}>Grade</th>
                        <th style={{ width: "auto" }}>Comments</th>
                        <th style={{ width: "180px" }}>H․R Teacher</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        grade.map((item, idx) => {
                            return (
                                <tr key={`behavioral-${item}`} className={`behavioral-${idx}`}>
                                    <td>{item.toUpperCase()}</td>
                                    <td>
                                        <Controller
                                            name={`behavioral.${item}.comment`}
                                            control={control}
                                            render={({ field }) => (
                                                isRead
                                                    ? <HtmlPrintBox value={field.value} />
                                                    : <ReactQuill
                                                        theme="snow"
                                                        value={field.value}
                                                        onChange={field.onChange}
                                                        modules={reactQuillModules}
                                                        formats={reactQuillFormats}
                                                        style={{ height: '300px', marginBottom: '80px' }}
                                                    />
                                            )}
                                        />
                                    </td>
                                    <td>
                                        <SchoolRecordInput register={register} name={`behavioral.${item}.teacher`} isRead={isRead} />
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default BehavioralRemarkTable